import { addPermissionsToRoute } from '@qsrsoft/myq-core';
const routes = {
  name: 'Cash',
  icon: 'mdi-cash',
  path: '/reports/cash',
  menuFilters: {
    $and: [
      { countryCode: { $in: ['za'] } },
      { enterpriseClient: { $eq: 'McDonalds' } },
    ],
  },
  children: [
    {
      path: '/reports/cash/cashSheet',
      name: 'Cash Sheet',
      meta: { id: 'mc-cashSheet', permission: 'mtCash' },
      component: () => import('./cashsheet/CashsheetWrapper.vue'),
      ...addPermissionsToRoute(['mtCash']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    },
    {
      path: '/reports/cash/tax',
      name: 'Tax Exempt',
      meta: { id: 'mc-taxExempt', permission: 'mtCash' },
      component: () => import('./tax/TaxWrapper.vue'),
      ...addPermissionsToRoute(['mtCash']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    },
    {
      path: '/reports/cash/registerAudit',
      name: 'Register Audit',
      meta: { id: 'mc-registerAudit', permission: 'mtCash' },
      component: () => import('./RegisterAudit.vue'),
      ...addPermissionsToRoute(['mtCash']),
      menuFilters: {
        $and: [
          { countryCode: { $in: ['za'] } },
          { enterpriseClient: { $eq: 'McDonalds' } },
        ],
      },
    },
    // {
    //   path: '/reports/cash/cashless',
    //   name: 'Cashless',
    //   meta: { id: 'mc-cashless', permission: 'mtCash' },
    //   component: () => import('./CashlessWrapper.vue'),
    //   ...addPermissionsToRoute(['mtCash']),
    // },
    // {
    //   path: '/reports/cash/giftCardSummary',
    //   name: 'Gift Card Summary',
    //   meta: { id: 'mc-giftCardSummary', permission: 'mtCash' },
    //   component: () => import('./GiftCardSummary.vue'),
    //   ...addPermissionsToRoute(['mtCash']),
    // },
  ],
};

export default routes;
